import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import moment from 'moment-timezone';
import { useTheme } from '@mui/material/styles';

import PageHeader from 'components/Header/Page';
import PageWrapper from 'components/Common/PageWraper';

import { ReactComponent as EditIcon } from '../../assets/PepWise2.0/Edit-Menu-Icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/PepWise2.0/Delete-Menu-Icon.svg';
import LinearProgress from 'components/Widgets/LinearProgress';
import DataPipelineProjectCard from 'components/Widgets/DataPipelineProjectCard';
import { InfoTooltip } from 'components/Widgets/InfoTooltip';
import CustomAccordion from 'components/Accordion/CustomAccordion';
import SectorCard from 'components/Widgets/SectorCard';

const SAMPLE_PROGRAM_DATA = [
  {
    programName: 'Daily PBNA Supply Chain',
    programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
    sector: 'PBNA',
    isProgramActive: 1,
    order: 1,
    legendData: [
      {
        iconPath: '../../assets/PepWise2.0/SLA Met.svg',
        colorCode: 'rgba(1, 192, 8, 1)',
        txt: 'SLA Met',
      },
      {
        iconPath: '../../assets/PepWise2.0/SLA Not Met.svg',
        colorCode: 'rgba(254, 38, 38, 1)',
        txt: 'SLA Not Met',
      },
      {
        iconPath: '../../assets/PepWise2.0/In Progress.svg',
        colorCode: 'rgba(236, 185, 20, 1)',
        txt: 'In Progress',
      },
      {
        iconPath: '../../assets/PepWise2.0/Not Started.svg',
        colorCode: 'rgba(169, 173, 203, 1)',
        txt: 'Not Started',
      },
      {
        iconPath: '../../assets/PepWise2.0/At Risk.svg',
        colorCode: 'rgba(253, 120, 59, 1)',
        txt: 'At Risk',
      },
    ],
    exeProgramEta: null,
    contactInfo: {
      name: 'Srinivas Kesavareddy / Srinivasan Palanisamy',
      email: 'srinivas.kesavareddy@pepsico.com / srinivasan.palanisamy@pepsico.com',
      phone: '14698828358 / 19453468761',
      programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
    },
    projectDetails: [
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: 'b7052e4a-fcf8-4b86-a782-0a155befe402',
        order: 1,
        scheduleDate: '2026-03-10',
        projectName: 'BODS',
        sectors: 'PBNA',
        slaStatus: 'SLA Missed',
        actualStartTime: '2026-03-09T05:00:02.0000000Z',
        actualCompletionTime: '2026-03-10T03:27:46.0000000Z',
        colorCode: 'rgba(254, 38, 38, 1)',
        dataAvailability: 90,
        runningDayIndexes: [0, 6],
        timePosition: 0,
        totalJobs: 34,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: 'ea7ffe59-9fa3-4b1d-802c-c131ac46d110',
          projectName: 'BODS',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Anji Mallavaram',
          email: 'anji.mallavaram@pepsico.com',
          phone: '14692987782',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [0, 6],
          last30days: [0, 13],
          last90days: [0, 23],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 3:00',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: 'e4364f64-6673-4f58-bf73-5b8127ba8e68',
        order: 2,
        scheduleDate: '2026-03-10',
        projectName: 'MDT',
        sectors: 'PBNA',
        slaStatus: 'SLA Missed',
        actualStartTime: '2026-03-09T06:45:32.0000000Z',
        actualCompletionTime: '2026-03-10T21:01:41.0000000Z',
        colorCode: 'rgba(254, 38, 38, 1)',
        dataAvailability: 70,
        runningDayIndexes: [0, 1, 6],
        timePosition: 0,
        totalJobs: 34,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: '4d307470-2b41-4c9b-9286-00c95e51337c',
          projectName: 'MDT',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Vidya Ramachandra Prabhu',
          email: 'Vidya.RamachandraPrabhu@pepsico.com',
          phone: '19729636866',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [0, 6],
          last30days: [0, 13],
          last90days: [0, 28],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 5:00',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: '5bbe5a90-8e14-4f3b-8f5c-386a8a592153',
        order: 3,
        scheduleDate: '2026-03-10',
        projectName: 'GEDW',
        sectors: 'PBNA',
        slaStatus: 'SLA Missed',
        actualStartTime: '2026-03-09T07:00:00.0000000Z',
        actualCompletionTime: '2026-03-10T08:43:19.0000000Z',
        colorCode: 'rgba(254, 38, 38, 1)',
        dataAvailability: 90,
        runningDayIndexes: [0, 3, 4, 6],
        timePosition: 0,
        totalJobs: 56,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: 'd4272d5e-0248-4e64-ae0f-37b185ca2d96',
          projectName: 'GEDW',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Manikandan Balasubramanian / Patrick Liu',
          email: 'manikandan.balasubramanian@pepsico.com / patrick.liu@pepsico.com',
          phone: '+918978480943 / --',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [0, 6],
          last30days: [0, 13],
          last90days: [0, 23],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 6:30',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: '968fbcc4-5a58-4a3e-baca-504b15685d40',
        order: 4,
        scheduleDate: '2026-03-10',
        projectName: 'PBNA EDW',
        sectors: 'PBNA',
        slaStatus: 'SLA Met',
        actualStartTime: '2026-03-09T11:00:01.000Z',
        actualCompletionTime: '2026-03-10T07:50:27.000Z',
        colorCode: 'rgba(1, 192, 8, 1)',
        dataAvailability: 90,
        runningDayIndexes: [2, 3, 4],
        timePosition: 0,
        totalJobs: 9,
        exeProjectEta: null,
        hopType: 'program',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 64,
          programName: 'PBNA EDW Supply Chain Critical Jobs Status Report',
          hopType: 'program',
          sstnPrjctId: null,
          projectName: '',
          hyperLink: null,
          version: 'v1',
        },
        contactInfo: {
          name: 'Manikandan Balasubramanian',
          email: 'manikandan.balasubramanian@pepsico.com',
          phone: '+918978480943',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [6, 1],
          last30days: [10, 4],
          last90days: [22, 8],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 8:00',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: '1f3a4d22-9a9e-4c9f-a7db-2f5d9e6b1001',
        order: 5,
        scheduleDate: '2026-03-10',
        projectName: 'SCPO',
        sectors: 'PBNA',
        slaStatus: 'SLA Met',
        actualStartTime: '2026-03-09T09:15:10.0000000Z',
        actualCompletionTime: '2026-03-10T06:40:22.0000000Z',
        colorCode: 'rgba(1, 192, 8, 1)',
        dataAvailability: 95,
        runningDayIndexes: [1, 2, 3, 4, 5],
        timePosition: 0,
        totalJobs: 18,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: '6cde2a4b-30a8-4aa3-9b59-0b12ec991101',
          projectName: 'SCPO',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Rakesh Nair',
          email: 'rakesh.nair@pepsico.com',
          phone: '+14155550101',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [6, 1],
          last30days: [24, 4],
          last90days: [72, 9],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 7:15',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: '2a4b5c66-7d88-4b11-9d22-3e6f7a8c1002',
        order: 6,
        scheduleDate: '2026-03-10',
        projectName: 'DPS',
        sectors: 'PBNA',
        slaStatus: 'SLA Missed',
        actualStartTime: '2026-03-09T10:05:45.0000000Z',
        actualCompletionTime: '2026-03-10T12:18:31.0000000Z',
        colorCode: 'rgba(254, 38, 38, 1)',
        dataAvailability: 65,
        runningDayIndexes: [0, 2, 4, 6],
        timePosition: 0,
        totalJobs: 27,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: '7d0c2d3e-41f9-4f33-a2e4-1b34fd221102',
          projectName: 'DPS',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Priya Menon',
          email: 'priya.menon@pepsico.com',
          phone: '+14155550102',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [2, 5],
          last30days: [8, 12],
          last90days: [21, 26],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 9:00',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: '3b5c6d77-8e99-4c22-b333-4f7a8b9d1003',
        order: 7,
        scheduleDate: '2026-03-10',
        projectName: 'FDP',
        sectors: 'PBNA',
        slaStatus: 'In Progress',
        actualStartTime: '2026-03-10T01:10:00.0000000Z',
        actualCompletionTime: null,
        colorCode: 'rgba(255, 153, 0, 1)',
        dataAvailability: 50,
        runningDayIndexes: [1, 2, 3, 4, 5, 6],
        timePosition: 0,
        totalJobs: 14,
        exeProjectEta: '2026-03-11T00:00:00.0000000Z',
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: '8e1d3e4f-52aa-4f44-b3f5-2c45ab331103',
          projectName: 'FDP',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Arun Krishnan',
          email: 'arun.krishnan@pepsico.com',
          phone: '+14155550103',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [4, 2],
          last30days: [16, 6],
          last90days: [44, 15],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 11:30',
      },
      {
        programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        projectId: '4c6d7e88-9faa-4d33-c444-5a8b9c0e1004',
        order: 8,
        scheduleDate: '2026-03-10',
        projectName: 'RMF',
        sectors: 'PBNA',
        slaStatus: 'SLA Met',
        actualStartTime: '2026-03-09T08:25:15.0000000Z',
        actualCompletionTime: '2026-03-10T05:12:09.0000000Z',
        colorCode: 'rgba(1, 192, 8, 1)',
        dataAvailability: 88,
        runningDayIndexes: [0, 1, 2, 3, 4],
        timePosition: 0,
        totalJobs: 22,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'f7944e88-5287-4fe4-88ed-64ed3175ff87',
          programName: 'PBNA Supply Chain',
          hopType: 'project',
          sstnPrjctId: '9f2e4f50-63bb-4f55-c4a6-3d56bc441104',
          projectName: 'RMF',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Sneha Iyer',
          email: 'sneha.iyer@pepsico.com',
          phone: '+14155550104',
          programId: 'e4700f6c-43d5-42da-b219-485ca75365d0',
        },
        slaTrend: {
          last7days: [7, 0],
          last30days: [25, 3],
          last90days: [68, 7],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 6:00',
      },
    ],
    slaStatus: 'SLA Met',
    platformHealth: '',
    exeColorCode: 'rgba(1, 192, 8, 1)',
    exeIconPath: '../../assets/PepWise2.0/SLA Met.svg',
    progress: 0,
    is_deleted: 0,
  },
  {
    programName: 'Daily PBNA Cockpit 3.0 Sales',
    programId: 'a0d49ab3-88fb-4b70-a166-bb2738d73723',
    sector: 'PBNA',
    isProgramActive: 1,
    order: 6,
    legendData: [
      {
        iconPath: '../../assets/PepWise2.0/SLA Met.svg',
        colorCode: 'rgba(1, 192, 8, 1)',
        txt: 'SLA Met',
      },
      {
        iconPath: '../../assets/PepWise2.0/SLA Not Met.svg',
        colorCode: 'rgba(254, 38, 38, 1)',
        txt: 'SLA Not Met',
      },
      {
        iconPath: '../../assets/PepWise2.0/In Progress.svg',
        colorCode: 'rgba(236, 185, 20, 1)',
        txt: 'In Progress',
      },
      {
        iconPath: '../../assets/PepWise2.0/Not Started.svg',
        colorCode: 'rgba(169, 173, 203, 1)',
        txt: 'Not Started',
      },
      {
        iconPath: '../../assets/PepWise2.0/At Risk.svg',
        colorCode: 'rgba(253, 120, 59, 1)',
        txt: 'At Risk',
      },
    ],
    exeProgramEta: null,
    contactInfo: {
      name: 'Ravi Gopalan / Srinivasan Palanisamy',
      email: 'Ravi.Gopalan@pepsico.com / Srinivasan.Palanisamy@pepsico.com',
      phone: '19147671281 / 19453468761',
      programId: 'a0d49ab3-88fb-4b70-a166-bb2738d73723',
    },
    projectDetails: [
      {
        programId: 'a0d49ab3-88fb-4b70-a166-bb2738d73723',
        projectId: 'a192e0e9-c30a-4e75-95fc-7d915831e4cf',
        order: 1,
        scheduleDate: '2026-03-10',
        projectName: 'BODS(Sybase to GBI)',
        sectors: 'PBNA',
        slaStatus: 'SLA Met',
        actualStartTime: '2026-03-10T03:48:00.0000000Z',
        actualCompletionTime: '2026-03-10T03:56:42.0000000Z',
        colorCode: 'rgba(1, 192, 8, 1)',
        dataAvailability: 80,
        runningDayIndexes: [0, 4],
        timePosition: 0,
        totalJobs: 0,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'a23436e8-685c-412d-874f-b02f2ef3f8c1',
          programName: 'Daily PBNA Cockpit 3.0 Sales',
          hopType: 'project',
          sstnPrjctId: 'd958be22-db85-4a44-9e1a-17ad4795027f',
          projectName: 'BODS(Sybase to GBI)',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Tyrone Turner',
          email: 'Tyrone.Turner@pepsico.com',
          phone: '1-214-4508727',
          programId: 'a0d49ab3-88fb-4b70-a166-bb2738d73723',
        },
        slaTrend: {
          last7days: [4, 3],
          last30days: [9, 5],
          last90days: [10, 12],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 4:00',
      },
      {
        programId: 'a0d49ab3-88fb-4b70-a166-bb2738d73723',
        projectId: '82df090e-32cb-42eb-bf05-160697e975b0',
        order: 2,
        scheduleDate: '2026-03-10',
        projectName: 'S4 Standard Billing Jobs',
        sectors: 'PBNA',
        slaStatus: 'SLA Missed',
        actualStartTime: '2026-03-10T00:43:28.0000000Z',
        actualCompletionTime: '2026-03-10T16:24:52.0000000Z',
        colorCode: 'rgba(254, 38, 38, 1)',
        dataAvailability: 50,
        runningDayIndexes: [3, 4],
        timePosition: 0,
        totalJobs: 1,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: 'a23436e8-685c-412d-874f-b02f2ef3f8c1',
          programName: 'Daily PBNA Cockpit 3.0 Sales',
          hopType: 'project',
          sstnPrjctId: 'f077f5d6-e986-4712-9865-7a7a6e408c39',
          projectName: 'S4 Standart Billing JOBS ',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'PATRICIA DOS SANTOS',
          email: 'PATRICIA.DOSSANTOS@pepsico.com',
          phone: '2032465281',
          programId: 'a0d49ab3-88fb-4b70-a166-bb2738d73723',
        },
        slaTrend: {
          last7days: [0, 7],
          last30days: [0, 14],
          last90days: [0, 22],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 2:00',
      },
    ],
    slaStatus: 'SLA Missed',
    platformHealth: '',
    exeColorCode: 'rgba(254, 38, 38, 1)',
    exeIconPath: '../../assets/PepWise2.0/SLA Not Met.svg',
    progress: 0,
    is_deleted: 0,
  },
  {
    programName: 'Weekly PBNA Cockpit 3.0 Sales',
    programId: '68851b1d-4d6b-4a13-9228-3e770ffc3558',
    sector: 'PBNA',
    isProgramActive: 1,
    order: 9,
    legendData: [
      {
        iconPath: '../../assets/PepWise2.0/SLA Met.svg',
        colorCode: 'rgba(1, 192, 8, 1)',
        txt: 'SLA Met',
      },
      {
        iconPath: '../../assets/PepWise2.0/SLA Not Met.svg',
        colorCode: 'rgba(254, 38, 38, 1)',
        txt: 'SLA Not Met',
      },
      {
        iconPath: '../../assets/PepWise2.0/In Progress.svg',
        colorCode: 'rgba(236, 185, 20, 1)',
        txt: 'In Progress',
      },
      {
        iconPath: '../../assets/PepWise2.0/Not Started.svg',
        colorCode: 'rgba(169, 173, 203, 1)',
        txt: 'Not Started',
      },
      {
        iconPath: '../../assets/PepWise2.0/At Risk.svg',
        colorCode: 'rgba(253, 120, 59, 1)',
        txt: 'At Risk',
      },
    ],
    exeProgramEta: null,
    contactInfo: {
      name: 'Srinivasan Palanisamy / Ravi Gopalan',
      email: 'Srinivasan.Palanisamy@pepsico.com / Ravi.Gopalan@pepsico.com',
      phone: '19453468761 / 19147671281',
      programId: '68851b1d-4d6b-4a13-9228-3e770ffc3558',
    },
    projectDetails: [
      {
        programId: '68851b1d-4d6b-4a13-9228-3e770ffc3558',
        projectId: 'd84736ec-7330-4f29-b501-5a863fe33aef',
        order: 1,
        scheduleDate: '2026-03-10',
        projectName: 'FP&A View to Ehana',
        sectors: 'PBNA',
        slaStatus: 'Not Started',
        actualStartTime: '',
        actualCompletionTime: '',
        colorCode: 'rgba(169, 173, 203, 1)',
        dataAvailability: 30,
        runningDayIndexes: [0, 5],
        timePosition: 0,
        totalJobs: 1,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: '64eff854-feec-4c5c-84cb-8f839ec22290',
          programName: 'Weekly PBNA Cockpit 3.0 Sales',
          hopType: 'project',
          sstnPrjctId: '887ab5ea-42ff-4032-9936-509a76d56f6d',
          projectName: 'FP&A View to Ehana',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Srinivas Kesavareddy',
          email: 'Srinivas.Kesavareddy@pepsico.com',
          phone: '19147676405',
          programId: '68851b1d-4d6b-4a13-9228-3e770ffc3558',
        },
        slaTrend: {
          last7days: [0, 1],
          last30days: [1, 1],
          last90days: [1, 2],
        },
        isAvailable: 1,
        slaTime: '23:59',
      },
      {
        programId: '68851b1d-4d6b-4a13-9228-3e770ffc3558',
        projectId: '9454812f-d1eb-446b-8540-6f3e36d46b51',
        order: 9,
        scheduleDate: '2026-03-10',
        projectName: 'Cockpit Refresh',
        sectors: 'PBNA',
        slaStatus: 'SLA Missed',
        actualStartTime: '2026-03-10T03:09:44.0000000Z',
        actualCompletionTime: '2026-03-10T04:36:13.0000000Z',
        colorCode: 'rgba(254, 38, 38, 1)',
        dataAvailability: 50,
        runningDayIndexes: [0, 3],
        timePosition: 0,
        totalJobs: 1,
        exeProjectEta: null,
        hopType: 'project',
        platformHealthLink: null,
        sstnPrgrmName: '',
        sstnProgramId: '',
        contact: {
          programId: '64eff854-feec-4c5c-84cb-8f839ec22290',
          programName: 'PBNA Weekly E2E Sales Reporting 3.0',
          hopType: 'project',
          sstnPrjctId: '81792ff0-4da1-45c1-9eb4-e49a8640c66b',
          projectName: 'Cockpit Refresh',
          hyperLink: null,
          version: 'v2',
        },
        contactInfo: {
          name: 'Gary Brady',
          email: 'Gary.Brady@pepsico.com',
          phone: '19147676405',
          programId: '68851b1d-4d6b-4a13-9228-3e770ffc3558',
        },
        slaTrend: {
          last7days: [0, 3],
          last30days: [0, 6],
          last90days: [0, 13],
        },
        isAvailable: 1,
        slaTime: '2026-03-10 5:00',
      },
    ],
    slaStatus: 'SLA Missed',
    platformHealth: '',
    exeColorCode: 'rgba(254, 38, 38, 1)',
    exeIconPath: '../../assets/PepWise2.0/SLA Not Met.svg',
    progress: 0,
    is_deleted: 0,
  },
];

// Sector Accordion sample data
const programList = {
  AMESA: [
    {
      Sector_Bucket: 'AMESA',
      Program_id: 'e9693c62-f137-4af4-adc6-e715217253bb',
      Program_Name: 'Cloud 05',
      Created_dt: '2026-02-19T00:09:37.723Z',
      Updated_dt: '2026-02-19T00:09:37.723Z',
      Exec_Time: '2026-04-08T09:30:00.000Z',
      Next_Exec_Time: '2026-04-09T09:30:00.000Z',
      ProjectCount: 0,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 0,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
      statusBadgeLabel: '',
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '18af17f2-4cfd-499c-9d40-fba550f6d2c3',
      Program_Name: 'Program 01',
      Created_dt: '2026-02-13T02:41:04.690Z',
      Updated_dt: '2026-02-13T02:41:04.690Z',
      Exec_Time: '2026-04-08T10:00:00.000Z',
      Next_Exec_Time: '2026-04-09T10:00:00.000Z',
      ProjectCount: 1,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 1,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
      statusBadgeLabel: 'AT RISK',
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '25b9ddfe-a9a4-4985-bbd5-6723e400534b',
      Program_Name: 'Program 02',
      Created_dt: '2026-02-11T05:39:59.314Z',
      Updated_dt: '2026-02-11T05:39:59.314Z',
      Exec_Time: '2026-04-08T11:15:00.000Z',
      Next_Exec_Time: '2026-04-09T11:15:00.000Z',
      ProjectCount: 8,
      SLA_Met_Count: 3,
      SLA_Missed_Count: 2,
      In_Progress_Count: 2,
      Scheduled_Count: 2,
      statusBadgeLabel: '',
    },
    {
      Sector_Bucket: 'AMESA',
      Program_id: '5f81e53b-3599-4559-97a0-9f865f1c6b88',
      Program_Name: 'Program 03',
      Created_dt: '2025-12-01T11:15:31.000Z',
      Updated_dt: '2025-12-01T11:15:31.000Z',
      Exec_Time: '2026-04-08T13:00:00.000Z',
      Next_Exec_Time: '2026-04-09T13:00:00.000Z',
      ProjectCount: 3,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 1,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
      statusBadgeLabel: '',
    },
  ],
  PBNA: [
    {
      Sector_Bucket: 'PBNA',
      Program_id: '18af17f2-4cfd-499c-9d40-fba550f6d2cr',
      Program_Name: 'Program 01',
      Created_dt: '2026-02-13T02:41:04.690Z',
      Updated_dt: '2026-02-13T02:41:04.690Z',
      Exec_Time: '2026-04-08T10:00:00.000Z',
      Next_Exec_Time: '2026-04-09T10:00:00.000Z',
      ProjectCount: 1,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 1,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
      statusBadgeLabel: 'AT RISK',
    },
    {
      Sector_Bucket: 'PBNA',
      Program_id: '25b9ddfe-a9a4-4985-bbd5-6723e400534t',
      Program_Name: 'Program 02',
      Created_dt: '2026-02-11T05:39:59.314Z',
      Updated_dt: '2026-02-11T05:39:59.314Z',
      Exec_Time: '2026-04-08T11:15:00.000Z',
      Next_Exec_Time: '2026-04-09T11:15:00.000Z',
      ProjectCount: 8,
      SLA_Met_Count: 3,
      SLA_Missed_Count: 2,
      In_Progress_Count: 2,
      Scheduled_Count: 2,
      statusBadgeLabel: '',
    },
    {
      Sector_Bucket: 'PBNA',
      Program_id: '5f81e53b-3599-4559-97a0-9f865f1c6b8y',
      Program_Name: 'Program 03',
      Created_dt: '2025-12-01T11:15:31.000Z',
      Updated_dt: '2025-12-01T11:15:31.000Z',
      Exec_Time: '2026-04-08T13:00:00.000Z',
      Next_Exec_Time: '2026-04-09T13:00:00.000Z',
      ProjectCount: 3,
      SLA_Met_Count: 0,
      SLA_Missed_Count: 1,
      In_Progress_Count: 0,
      Scheduled_Count: 0,
      statusBadgeLabel: '',
    },
  ],
};

type ProgramItem = {
  Sector_Bucket: string;
  Program_id: string;
  Program_Name: string;
  Created_dt: string;
  Updated_dt: string;
  Exec_Time: string;
  Next_Exec_Time: string;
  ProjectCount: number;
  SLA_Met_Count: number;
  SLA_Missed_Count: number;
  In_Progress_Count: number;
  Scheduled_Count: number;
};

const getProgramActionItems = (program: ProgramItem) => [
  {
    label: 'SLA Met',
    count: program.SLA_Met_Count,
    onBtnClick: () => console.log('SLA Met clicked', program.Program_id),
  },
  {
    label: 'SLA Missed',
    count: program.SLA_Missed_Count,
    onBtnClick: () => console.log('SLA Missed clicked', program.Program_id),
  },
  {
    label: 'In Progress',
    count: program.In_Progress_Count,
    onBtnClick: () => console.log('In Progress clicked', program.Program_id),
  },
  {
    label: 'Scheduled',
    count: program.Scheduled_Count,
    onBtnClick: () => console.log('Scheduled clicked', program.Program_id),
  },
];

export default function KPICardsDemoPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = theme.palette.dataPipeline.accordionWidget;
  const accordionHeaderColors = colors.accordionHeader;

  const [sectorName] = useState('PBNA');
  const [programData, setProgramData] = useState<any[]>([]);
  const [initialData, setInitialData] = useState<any[]>([]);
  const [timeLineInput, setTimeLineInput] = useState<any[]>([]);
  const [dataCardLoader, setDataCardLoader] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState<string | null>(null);
  const [, setActiveProgram] = useState<any>(null);
  const [openModal, setOpenModal] = useState<any>({ isOpen: false });

  const filteredPrograms = useMemo(() => {
    return programData.filter((program) => program.sector === sectorName);
  }, [programData, sectorName]);

  useEffect(() => {
    setProgramData(SAMPLE_PROGRAM_DATA);
    setInitialData(SAMPLE_PROGRAM_DATA);
  }, []);

  const handleDateChange = (dateValue: any) => {
    console.log('Selected Date:', dateValue);
  };

  const handleAccordianChange =
    (panel: string, _index: number, programId: string) => (_event: any, isExpanded: boolean) => {
      const selectedProgram = initialData.find((item: any) => item.programId === programId);

      setTimeLineInput(
        selectedProgram?.projectDetails?.filter((item: any) => item.isAvailable) || [],
      );
      setExpandedPanel(isExpanded ? panel : null);
      setActiveProgram(isExpanded ? programId : null);
    };

  const handleAction = (entity: string, action: string, program: any) => {
    console.log(`${action} clicked for`, program.Program_Name);
  };

  return (
    <PageWrapper>
      <PageHeader title="KPI Metric Card and Tooltip Demo">
        <Button variant="pepwiseSecondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </PageHeader>

      {filteredPrograms.map((program: any, index: number) => {
        const panelId = `panel${index + 1}`;
        const isExpanded = expandedPanel === panelId;

        return (
          <Box key={program.programId} mt={4} mb={3}>
            <CustomAccordion
              id={panelId}
              title={program.programName}
              expanded={isExpanded}
              onChange={
                program.isProgramActive
                  ? handleAccordianChange(panelId, index, program.programId)
                  : undefined
              }
              isActive={Boolean(program.isProgramActive)}
              statusLabel={program.slaStatus}
              contactInfo={program.contactInfo}
              statusImageUrl={program.exeIconPath}
              legendData={program.legendData}
              moreActionItems={[
                {
                  key: 'edit',
                  label: 'Edit',
                  icon: <EditIcon />,
                  onMenuClick: () => console.log('Edit clicked', program),
                },
                {
                  key: 'delete',
                  label: 'Delete',
                  icon: <DeleteIcon />,
                  onMenuClick: () => console.log('Delete clicked', program),
                },
              ]}
              etaLabel={
                <>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '13px',
                      color: accordionHeaderColors.tooltipTitle,
                      fontWeight: 500,
                      fontStyle: 'italic',
                    }}
                  >
                    Est. Arrival
                  </Typography>

                  <Typography variant="body2" sx={{ fontSize: '12px' }}>
                    {program.exeProgramEta
                      ? moment(program.exeProgramEta).utc().format('MMM DD, YYYY')
                      : '--'}
                  </Typography>
                </>
              }
              renderExpandedContent={
                timeLineInput?.length ? (
                  <LinearProgress timeline={timeLineInput} isPBNA />
                ) : (
                  <Box
                    sx={{ width: '100%' }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    Coming Soon
                  </Box>
                )
              }
              renderDetails={
                program.projectDetails?.length > 0 ? (
                  <Box>
                    <DataPipelineProjectCard
                      programId={program.programId}
                      projectDetails={program.projectDetails}
                      dataCardLoader={dataCardLoader}
                      handleDateChange={handleDateChange}
                      sector={sectorName}
                    />
                  </Box>
                ) : null
              }
              colors={colors}
            />
          </Box>
        );
      })}

      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          backgroundColor: '#fff',
        }}
      >
        <Typography sx={{ fontWeight: 600, color: '#000' }}>Different tooltips</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ mr: 1, color: '#000' }}>Basic text tooltip</Typography>
          <InfoTooltip label="This value is refreshed every 24 hours." />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ mr: 1, color: '#000' }}>List tooltip</Typography>
          <InfoTooltip
            label={[
              {
                title: 'Teradata (PROD)',
                description: 'Primary production warehouse used for reporting.',
              },
              {
                title: 'Azure',
                description: 'Used for ingestion, orchestration, and environment-level storage.',
              },
            ]}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ mr: 1, color: '#000' }}>Right placement tooltip</Typography>
          <InfoTooltip
            label="Appears on the right side on desktop."
            tooltipProps={{ placement: 'right' }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ mr: 1, color: '#000' }}>Custom React node tooltip</Typography>
          <InfoTooltip
            label={
              <Box
                sx={(theme) => ({
                  p: '12px 14px',
                  backgroundColor: theme.palette.tooltip.background.primary,
                  borderRadius: '12px',
                })}
              >
                <Typography
                  sx={(theme) => ({
                    color: theme.palette.tooltip.text.title,
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                  })}
                >
                  Data Stored In Teradata (PROD) &amp; Azure (All Environments)
                </Typography>

                <Typography
                  sx={(theme) => ({
                    mt: '6px',
                    color: theme.palette.tooltip.text.description,
                    fontSize: '14px',
                    fontStyle: 'italic',
                    fontWeight: 400,
                    lineHeight: '20px',
                  })}
                >
                  Data Available:{' '}
                  <Box
                    component="span"
                    sx={(theme) => ({
                      color: theme.palette.tooltip.text.description,
                      fontStyle: 'normal',
                      fontWeight: 600,
                    })}
                  >
                    From 2023-12-12 To 2024-12-12
                  </Box>
                </Typography>
              </Box>
            }
            sx={{ ml: '6px', mt: '2px' }}
            tooltipProps={{
              placement: 'top',
              slotProps: {
                tooltip: {
                  sx: (theme) => ({
                    p: 0,
                    maxWidth: 320,
                    bgcolor: theme.palette.tooltip.background.primary,
                    color: theme.palette.tooltip.text.primary,
                    borderRadius: '12px',
                    boxShadow: `
                -6px 6px 12px rgba(0, 0, 0, 0.18),
                -2px 10px 8px rgba(0, 0, 0, 0.12)
              `,
                  }),
                },
              },
            }}
          />
        </Box>
      </Box>

      {Object.entries(programList).map(([sector, programs], sectorIndex) => {
        const panelId = `sector-panel-${sectorIndex}`;
        const isExpanded = expandedPanel === panelId;

        return (
          <Box key={sector} mt={2}>
            <CustomAccordion
              id={panelId}
              title={sector}
              expanded={isExpanded}
              onChange={() =>
                setExpandedPanel((prev: string | null) => (prev === panelId ? null : panelId))
              }
              isActive
              statusLabel={sector}
              moreActionItems={[
                {
                  key: 'edit',
                  label: 'Edit',
                  icon: <EditIcon />,
                  onMenuClick: () => console.log('Edit sector clicked', sector),
                },
                {
                  key: 'delete',
                  label: 'Delete',
                  icon: <DeleteIcon />,
                  onMenuClick: () => console.log('Delete sector clicked', sector),
                },
              ]}
              // renderExpandedContent={null}
              renderDetails={
                <Box
                  sx={{
                    width: '100%',
                    p: 2,
                    boxSizing: 'border-box',
                    backgroundColor: colors.background.page,
                  }}
                >
                  <Grid container spacing={2}>
                    {(programs as any[]).map((program: any) => {
                      const statusCount =
                        (program.SLA_Missed_Count || 0) +
                        (program.SLA_Met_Count || 0) +
                        (program.Scheduled_Count || 0) +
                        (program.In_Progress_Count || 0);

                      return (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={program.Program_id}>
                          <SectorCard
                            title={program.Program_Name}
                            sectorId={program.Program_id}
                            totalLabel="TOTAL STAGES"
                            totalCount={program.ProjectCount}
                            sectionLabel="Stage SLAs"
                            execTime={program.Exec_Time}
                            nextExec={program.Next_Exec_Time}
                            statusBadgeLabel={program.statusBadgeLabel}
                            actionItems={getProgramActionItems(program)}
                            emptyStateText={statusCount === 0 ? 'No Data' : ''}
                            addButtonLabel="ADD PROJECT"
                            isEditEnabled
                            infoTooltip={{
                              dateValues: [
                                { label: 'Date Created', value: program.Created_dt },
                                { label: 'Last Updated', value: program.Updated_dt },
                              ],
                            }}
                            infoOptionMenu={{
                              menuItems: [
                                {
                                  key: 'edit',
                                  label: 'Edit',
                                  icon: <EditIcon />,
                                  onMenuClick: () => handleAction('Program', 'edit', program),
                                },
                                {
                                  key: 'delete',
                                  label: 'Delete',
                                  icon: <DeleteIcon />,
                                  onMenuClick: () => handleAction('Program', 'delete', program),
                                },
                              ],
                              sx: { width: '20px', height: '20px' },
                            }}
                            containerProps={{
                              sx: {
                                width: '100%',
                              },
                            }}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              }
              colors={colors}
            />
          </Box>
        );
      })}
    </PageWrapper>
  );
}
